import { useState } from "react";
import { TourModal } from "../tours-modal/TourModal";
import { TourDateGroup } from "../tours-date-group/TourDateGroup";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from "@/shared/components/ui/pagination";
import type {
  TourCard,
  TourDateGroup as TourDateGroupType,
} from "../../types/history";
import { TIMEZONE } from "../../constants/periods";

interface TourCardsSectionProps {
  groups: TourDateGroupType[];
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

function todayInAlmaty(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

export function ToursCardsSection({
  groups,
  page,
  totalPages,
  onPageChange,
}: TourCardsSectionProps) {
  const [selectedCard, setSelectedCard] = useState<TourCard | null>(null);
  const today = todayInAlmaty();

  return (
    <div className="container space-y-8">
      {groups.map((group) => (
        <TourDateGroup
          key={group.date}
          group={group}
          isToday={group.date === today}
          onOpen={setSelectedCard}
        />
      ))}

      {totalPages > 1 && (
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={() => onPageChange(Math.max(1, page - 1))}
                aria-disabled={page === 1}
                className={page === 1 ? "pointer-events-none opacity-50" : ""}
              />
            </PaginationItem>
            <PaginationItem>
              <span className="text-sm text-muted-foreground px-4">
                {page} / {totalPages}
              </span>
            </PaginationItem>
            <PaginationItem>
              <PaginationNext
                onClick={() => onPageChange(Math.min(totalPages, page + 1))}
                aria-disabled={page === totalPages}
                className={
                  page === totalPages ? "pointer-events-none opacity-50" : ""
                }
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      )}

      <TourModal
        card={selectedCard}
        open={!!selectedCard}
        onClose={() => setSelectedCard(null)}
      />
    </div>
  );
}
